export default __webpack_public_path__ + "static/media/cases7@2x.6fa9cf43.jpg";